module.exports = __webpack_public_path__ + "static/media/bai_top.316d3038.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/bai_top.png
// module id = 1464
// module chunks = 0